import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

const TopicPage = () => {
    const { slug } = useParams();
    const [topic, setTopic] = useState(null);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        setNotFound(false);
        setTopic(null);
        api.get(`/topics/${slug}`)
            .then(r => setTopic(r.data))
            .catch(() => setNotFound(true));
    }, [slug]);

    if (notFound) {
        return (
            <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="topic-notfound">
                <h1 className="font-serif text-3xl">A room not yet built</h1>
                <p className="mt-4 text-muted-foreground italic">This pathway is coming soon.</p>
                <Link to="/" className="mt-6 inline-block small-caps text-xs accent-liturgy underline">Return home</Link>
            </div>
        );
    }

    if (!topic) {
        return <div className="max-w-2xl mx-auto px-6 py-24 text-center text-muted-foreground italic">Preparing this room…</div>;
    }

    return (
        <div className="max-w-4xl mx-auto px-6 md:px-10 py-16" data-testid={`topic-${slug}`}>
            <div className="text-center mb-10">
                <div className="small-caps text-[11px] accent-liturgy tracking-widest">
                    Topic {String(topic.num).padStart(2, "0")} of 33 · {topic.group}
                </div>
                <h1 className="font-serif text-4xl md:text-5xl mt-3 leading-tight">{topic.title}</h1>
                {topic.subtitle && (
                    <p className="mt-3 text-lg text-muted-foreground italic">{topic.subtitle}</p>
                )}
            </div>

            <div className="missal-card p-10 md:p-14 text-center">
                <div className="small-caps text-[10px] accent-liturgy tracking-widest mb-4">Coming Soon</div>
                <p className="font-body text-base md:text-lg leading-loose text-foreground/85 italic max-w-2xl mx-auto">
                    This room is being prepared with sacred content — videos, prayers, teachings, and reflections tied to <span className="font-serif">{topic.title}</span>. The Companion will shortly take his seat here to speak with you about all things related.
                </p>
                <div className="mt-8">
                    <Link to="/" className="px-6 py-2 border border-liturgy accent-liturgy text-xs small-caps hover:bg-liturgy hover:text-white transition-colors">
                        Return to today
                    </Link>
                </div>
            </div>

            <p className="mt-10 text-center text-xs text-muted-foreground italic">
                Blessed be the Sacred Heart, the Immaculate Heart, and the Chaste Heart —
                <br />that we might learn from all three.
            </p>
        </div>
    );
};

export default TopicPage;
